import { disableBodyScroll, enableBodyScroll } from '~js/utils/dom';
import { renderDrawerModalMobile } from '../sections/pdp-mobile-drawer';

/* Represents the state of the quick add product drawer. */
const QuickAddProductDrawerMobile = {
  overlay: null,
  drawer: null,
  section: null,
  isLoading: false,
  handle: null,
  closeButton: null,
  previousWidth: window.innerWidth,
  ifdisplayedProductClicked: false,

  // Initialize the drawer and its functionality
  initialize() {
    this.initializeElements();
    this.hide();
    this.initializeCloseButton();

    // Expose trigger and hide functions for external access
    window.QuickBuyMobile = {
      trigger: this.trigger.bind(this),
      hide: this.hide.bind(this),
    };

    // Attach resize event listener to handle hiding on larger screens
    window.addEventListener('resize', this.handleResize.bind(this));

    // Initial check for the screen size
    this.handleResize();
  },

  // Initialize elements
  initializeElements() {
    this.overlay = document.querySelector('.js-pdp-mobile-drawer-overlay');
    this.drawer = this.overlay.querySelector('.js-pdp-mobile-drawer');
    this.section = this.drawer.querySelector(
      '.js-pdp-mobile-drawer-section-content',
    );
    this.closeButton = this.section.querySelector(
      '.js-quick-product-close-btn',
    );
  },

  // Show the drawer by manipulating CSS classes
  show() {
    this.overlay.parentElement.classList.add('is-drawer-open');
    disableBodyScroll();

    window.dispatchEvent(new CustomEvent('pdpVariantChange'));
  },

  // Hide the drawer by manipulating CSS classes
  hide() {
    this.overlay.parentElement.classList.remove('is-drawer-open');
    enableBodyScroll();

    window.dispatchEvent(new CustomEvent('syncVariantWithURL'));
  },

  // Initialize event listeners for the close button and outside clicks
  initializeCloseButton() {
    const closeDrawer = () => {
      this.hide(); // Call hide method to close the drawer
    };

    if (this.closeButton === null) return;
    this.closeButton.addEventListener('click', closeDrawer);
    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) {
        closeDrawer(); // Close drawer if clicking outside content
      }
    });
  },

  /**
   * Trigger method to handle showing the drawer with the appropriate Shopify product data.
   * @param {String} productHandle - product handle that is used to render the section and get the product data.
   * @param {String} ifdisplayedProductClicked - since we are updating the url in the pdp when the main pdp sticky button opens the quick drawer, we need to prevent the other section add to bag button from updating the url.
   */
  async trigger(productHandle, ifdisplayedProductClicked = false) {
    // If the handle is the same, just show the drawer
    if (this.handle === productHandle) {
      this.show();
      return;
    }

    if (this.isLoading) return;
    this.isLoading = true;
    this.handle = productHandle;
    this.ifdisplayedProductClicked = ifdisplayedProductClicked;

    try {
      const res = await fetch(
        `/products/${this.handle}?section_id=pdp-product-drawer`,
      );
      if (!res.ok) throw new Error('Fetch of quickAddProductDrawer failed');

      const productHTML = await res.text();
      renderDrawerModalMobile(
        this.section,
        productHTML,
        ifdisplayedProductClicked,
      );

      this.show();
      this.closeButton = this.section.querySelector(
        '.js-quick-product-close-btn',
      );
      if (this.closeButton) {
        this.initializeCloseButton();
      }
    } catch (err) {
      console.error(err.message);
      alert("Sorry, we couldn't load the Quick Add Product feature");
    } finally {
      this.isLoading = false;
    }
  },

  // Handle hiding the drawer on large screens, only if transitioning from <1024px to >=1024px
  handleResize() {
    const currentWidth = window.innerWidth;
    if (this.previousWidth < 1024 && currentWidth >= 1024) {
      this.hide();
    }
    this.previousWidth = currentWidth;
  },
};

export { QuickAddProductDrawerMobile };
